module.exports = __webpack_public_path__ + "img/drive-dil-3.88e3ec53.svg";